import { Navigate } from 'react-router-dom';
import { GuestRoute, ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { PhoneAuthPage } from '@/features/auth/pages/PhoneAuthPage';
import { OTPVerifyPage } from '@/features/auth/pages/OTPVerifyPage';
import { CompleteProfilePage } from '@/features/auth/pages/CompleteProfilePage';

export const authRoutes = [
  {
    path: '/auth/phone',
    element: (
      <GuestRoute>
        <PhoneAuthPage />
      </GuestRoute>
    ),
  },
  {
    path: '/auth/verify-otp',
    element: (
      <GuestRoute>
        <OTPVerifyPage />
      </GuestRoute>
    ),
  },
  {
    path: '/auth/complete-profile',
    element: (
      <ProtectedRoute>
        <CompleteProfilePage />
      </ProtectedRoute>
    ),
  },
];
